import { render, staticRenderFns } from "./aTestComp1.vue?vue&type=template&id=64715f7b"
import script from "./aTestComp1.vue?vue&type=script&lang=js"
export * from "./aTestComp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports